const SignoutIcon = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.99902 14H3.33236C2.97873 14 2.6396 13.8595 2.38955 13.6095C2.1395 13.3594 1.99902 13.0203 1.99902 12.6667V3.33333C1.99902 2.97971 2.1395 2.64057 2.38955 2.39052C2.6396 2.14048 2.97873 2 3.33236 2H5.99902'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.666 11.3346L13.9993 8.0013L10.666 4.66797'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M13.999 8H5.99902' strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default SignoutIcon
